/**
 * Year Filter Component
 *
 * Reusable year selector for filtering data by fiscal year
 */

import { Calendar } from 'lucide-react'

interface YearFilterProps {
  selectedYear: number
  onYearChange: (year: number) => void
  years?: number[]
  label?: string
  className?: string
}

export function YearFilter({
  selectedYear,
  onYearChange,
  years = [2567, 2566, 2565, 2564, 2563],
  label = 'ปีงบประมาณ',
  className = '',
}: YearFilterProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Calendar className="w-4 h-4 text-slate-500" />
      <label className="text-sm font-medium text-slate-700">{label}:</label>
      <select
        value={selectedYear}
        onChange={(e) => onYearChange(Number(e.target.value))}
        className="px-3 py-1.5 border border-slate-300 rounded-lg shadow-sm focus:ring-2 focus:ring-korat-orange-500 focus:border-korat-orange-500 bg-white text-sm font-medium text-slate-700 hover:border-slate-400 transition-colors"
      >
        {years.map((year) => (
          <option key={year} value={year}>
            พ.ศ. {year}
          </option>
        ))}
      </select>
    </div>
  )
}
